export default __webpack_public_path__ + "static/lightVector-0cb79db61a986288ec72b5110ab3929f.png";